import React from 'react';
import PropTypes from 'prop-types';
import styles from './QuizProgressBar.css';

function QuizProgressBar({ currentSlideIndex, totalSlides }) {
    const progress = currentSlideIndex ? (currentSlideIndex / totalSlides) * 100 : 0;

    return (
        <div className={styles.root}>
            <div className={styles.fill} style={{ width: `${progress}%` }} />
        </div>
    );
}

QuizProgressBar.propTypes = {
    currentSlideIndex: PropTypes.number,
    totalSlides: PropTypes.number
};

export {
    QuizProgressBar
};
